angular.module('jv.shareApplication.controller', [])
.controller('jvShareApplicationCandidateController', ['$scope', '$rootScope', 'TemplateLoader','jvHireBroadcastSVC',
    'jvCandidatesService', '$window', '$timeout', 'GAService',
    function($scope, $rootScope, TemplateLoader, jvHireBroadcastSVC, jvCandidatesService, $window, $timeout, GAService) {
        $scope.error = false;
        $scope.shareApplication = function() {
            if ((!$scope.shareApplicationObject.userEIds) || ($scope.shareApplicationObject.userEIds.length === 0)) {
                $scope.error = true;
            } else {
                $scope.error = false;
            }
            if (!$scope.error) {
                // validations here
                $scope.flags.loading = true;
                $scope.shareApplicationObject.applicationEIds = $scope.modalData.appIds;
                $scope.shareApplicationObject.subject = $scope.subject;
                $scope.shareApplicationObject.body = $scope.body;
                jvCandidatesService.shareApplication($scope.shareApplicationObject, function(res) {
                    $scope.flags.loading = false;
                    if (res.status === 200) {
                        $scope.showMsg('JV_SHAREAPPLICATION_CONTROLLER_SUCCESS_NOTICE');
                        GAService.track('Shared Application');
                    } else {
                        $scope.showMsg(res.message);
                    }
                    $scope.hideModals();
                });
            }
        };
        jvHireBroadcastSVC.subscribe('showShareApplicationModal', function(event, data) {
            $scope.modalData = angular.extend(data);
            $scope.showModals('shareApplication');
            $scope.init();
        });
        // Modal Information
        $scope.modals = {
            shareApplication: {
                show: false
            }
        };
        //Used to show the move modal
        $scope.showModals = function(modal) {
            TemplateLoader.load(modal).then(function() {
                $scope.modals[modal].show = true;
            });
        };
        $scope.hideModals = function() {
            $rootScope.$broadcast('hidingCandidateModals');
        };
        jvHireBroadcastSVC.subscribe('hidingCandidateModals', function() {
            $scope.error = false;
            $scope.modals.shareApplication.show = false;
        });

        $scope.init = function() {
            $scope.initData();
        };
        //Used to hide all the modals on the page
        $scope.hideShareApplicationModal = function() {
            $scope.init();
        };
        $scope.initData = function() {
            $scope.shareApplicationObject = {
                userEIds: [],
                applicationEIds: [],
                body: '',
                subject: ''
            };
            $scope.body = '';
            $scope.subject = i18n['SHARE_APP_SUBJECT'];
            $scope.submitted = false;
        };
        $scope.templates = TemplateLoader.register({
            shareApplication: '/jhire/modules/candidates/modals/shareApplication.html'
        });
    }
]);
